import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { field } from "./ui";

export const AssignPanel = ({ pkgs }) => {
  const [clients, setClients] = useState([]);
  const [map, setMap] = useState({});
  const [domains, setDomains] = useState([]);
  const load = () => api.get("/admin/twentyi/assignments").then((r) => setMap(Object.fromEntries(r.data.map((a) => [`${a.kind}:${a.ref}`, a.client_id])))).catch(() => {});
  useEffect(() => {
    api.get("/admin/twentyi/contacts").then((r) => setClients(r.data)).catch(() => {});
    api.get("/admin/twentyi/domains/purchases").then((r) => setDomains([...new Set(r.data.filter((p) => p.status === "registered").map((p) => p.domain))])).catch(() => {});
    load();
  }, []);
  const save = async (kind, ref, client_id) => {
    try { await api.put("/admin/twentyi/assignments", { kind, ref: String(ref), client_id: client_id || null }); toast.success("Saved"); load(); } catch { toast.error("Couldn't save"); }
  };
  const rows = [...(pkgs || []).filter((p) => !p.protected).map((p) => ["package", p.id, p.name]), ...domains.map((d) => ["domain", d, d])];
  return (
    <div data-testid="assign-panel" className="space-y-2">
      <p className="text-sm text-slate-400">Clients see assigned items read-only in their portal's Hosting tab.</p>
      {rows.map(([kind, ref, label]) => (
        <div key={`${kind}:${ref}`} className="flex items-center gap-3 text-sm text-white">
          <span className="w-20 text-xs uppercase text-slate-500">{kind}</span><span className="flex-1">{label}</span>
          <select value={map[`${kind}:${ref}`] || ""} onChange={(e) => save(kind, ref, e.target.value)} data-testid={`assign-${kind}-${ref}`} className={`${field} w-56`}>
            <option value="">Not assigned</option>{clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
      ))}
      {!rows.length && <p className="text-sm text-slate-500">Nothing to assign yet.</p>}
    </div>
  );
};
